<template>
  <main-layout>
    <v-layout wrap>
      <v-flex xs12 class="center-center hidden-md-and-up">
        <v-card elevation="32" :raised="true" class="mb-4">
          <v-card-title>Product Manager @ Google</v-card-title>
          <v-card-text class="text-left">
            Myself in bullet points:
            <ul>
              <li>Data-driven product manager with passion for technology as an enabler.</li>
              <li>Customer-focused, putting emphasis on doing the right thing.</li>
              <li>Software engineer with experience tackling both technical &amp; business challenges.</li>
              <li>7 years in Ad Tech, of which 5 in launching features generating multi-million dollars in revenue.</li>
              <li>Excellent communicator regularly engaging with clients and top management.</li>
              <li>Curious and open-minded person who has lived in 8 countries across Asia, Europe &amp; the US.</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="center-center">
        <v-btn min-height="4em" v-for="b in links" :key="b.id" :href="b.href" target="_blank" color="primary" class="mx-2 col-sm-12 col-md-3 mb-5">
          <v-icon>{{ b.icon }}</v-icon>
          &nbsp;
          {{ b.title }}
        </v-btn>
      </v-flex>
      <v-flex class="hidden-sm-and-down">
        <iframe src="https://cyrille.berliat.fr/cv/cv_html5/index.html"  width="90%" height="2050px" style="transform-origin: 0px 0px 0px; transform: scale(1.31119); padding-bottom: 0px; border: 0; margin-left: -15em" />
      </v-flex>
      <v-flex xs12 class="center-center hidden-sm-and-down" style="margin-top: 35em">
        <v-btn min-height="4em" v-for="b in links" :key="b.id" :href="b.href" target="_blank" color="primary" class="mx-2 col-3">
          <v-icon>{{ b.icon }}</v-icon>
          &nbsp;
          {{ b.title }}
        </v-btn>
      </v-flex>
    </v-layout>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'

  export default {
    name: "CV",  
    components: {
      MainLayout
    },
    data: () => ({
      links: [
        {id: 'pdf', title: 'PDF', icon: 'fab fa-download', href: 'cv/cv-us-cyrille_berliat.pdf'},
        {id: 'html5', title: 'HTML5', icon:'fab fa-html5', href: 'cv/cv_html5/index.html'},
        {id: 'linkedin', title: 'LinkedIn', icon: 'fab fa-linkedin', href: 'http://linkedin.com/in/cyrilleberliat'},
      ]
    })
  }
</script>